<template>
	<div v-show="itemsCount && itemsCount > 0">
		<pagination-custom
			:length="pagionationLength"
			@modelChanged="paginationCurrentPage = $event"
		/>
		<div class="BillingEnginePageInfo">
			{{paginationCurrentPage * 100 - 99}}
			{{txt.to}}
			{{paginationCurrentPage * 100}}
			{{txt.outof}}
			{{itemsCount}}
			{{txt.results}}
		</div>
	</div>
</template>

<script>
import PaginationCustom from '../arcCustom/PaginationCustom.vue'

export default {
	name: 'BillingEnginePagination',
	props: {
		itemsCount: {
			type: Number,
			required: true,
		},
	},
	components: {
		PaginationCustom,
	},
	data() {
		return {
			paginationCurrentPage: 1,
			txt: {
				results: 'results',
				outof: 'out of',
				to: 'to',
			},
		}
	},
	computed: {
		pagionationLength() {
			return Math.ceil(this.itemsCount / 100)
		},
	},
	watch: {
		paginationCurrentPage: {
			handler(value) {
				this.$emit('paginationCurrentPageChanged', value)
			},
		},
	},
	methods: {
	},
}
</script>

<style>

.BillingEnginePageInfo{
	background-color: rgb(221, 221, 221);
	color: rgb(37, 36, 36);
	margin-bottom: 50px;
}

</style>
